module.exports = __webpack_public_path__ + "static/media/gulden-logo.8b8f4d17.png";